import { render } from "./Radiology.vue?vue&type=template&id=a86ddf5e&scoped=true"
import script from "./Radiology.vue?vue&type=script&lang=ts"
export * from "./Radiology.vue?vue&type=script&lang=ts"

import "./Radiology.vue?vue&type=style&index=0&id=a86ddf5e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a86ddf5e"

export default script